import BuyingFilter from "../../components/filteration/buyingFilter";
import ShopAdds from "../../components/shopAds/ShopAdds";
import Shops from "../../components/Multipleshopprofile/Components/Shops/Shops";
import { Container, Row, Col } from "react-bootstrap";
import { useState, useEffect, useContext } from "react";
import ShareModel from "../../components/Sharemodel";
import ShareOption from "../../components/Shareoption";
import BackArrow from "../../components/backArrow";
import { ShopContext } from "../../config/shopContext";
import {
  useGetShopCategoriesQuery,
  useLazyGetFilteredSellVehiclesQuery,
} from "../../features/shop/shopApiSlice";
import "./buyUsedCars.css";

const BuyUsedCars = () => {
  const shopType = "usedVehicleShop"; // unique identifier for context
  const { getFilteredData, updateFilteredData } = useContext(ShopContext);
  const currentData = getFilteredData(shopType);

  const [isloading, setIsloading] = useState(false);
  const [dataCategory, setDataCategory] = useState({ categoryid: "" });
  const [showmodal, setShowmodal] = useState(false);
  const [showshare, setShowshare] = useState(false);

  const [shopdata, setShopdata] = useState(currentData.shopdata || []);
  const [itemmdata, setItemmdata] = useState(currentData.itemmdata || []);
  const [filters, setFilters] = useState(
    currentData.additionalData || {
      businessType: "usedVehicleShop",
      shopname: "",
      shopCategory: "",
      marketPlace: "",
      shopid: "",
      specialoffer: "",
      sale: "",
      itemname: "",
      categoryid: "",
      subCategoryid: "",
      country: "",
      state: "",
      city: "",
      salespromotion: "",
      min: "",
      max: "",
      brandName: "",
      modelYear: "",
    },
  );

  const handleClosemodal = () => setShowmodal(false);
  const handleShow = () => setShowmodal(true);
  const handleCloseshare = () => {
    setShowshare(false);
    setShowmodal(true);
  };
  const handleShowshare = () => setShowshare(true);

  const Handledata = (e) => {
    setDataCategory((prev) => ({
      ...prev,
      [e.target.name]: e.target.value.split("."),
    }));
  };

  const categoryName = dataCategory?.categoryid?.[1];
  const categoryidone = dataCategory?.categoryid?.[0];

  useEffect(() => {
    setFilters((prev) => ({ ...prev, categoryid: categoryidone || "" }));
  }, [categoryidone]);

  const [triggerFilter] = useLazyGetFilteredSellVehiclesQuery();

  const { data: createshopcategoryRes } = useGetShopCategoriesQuery({
    type: "usedVehicleShop",
    parentCategory: "",
  });
  const createshopcategory = createshopcategoryRes?.data?.Category;

  const { data: shopCategoryRes } = useGetShopCategoriesQuery({
    type: "usedVehicleShopItem",
    parentCategory: "",
  });
  const shopCategory = shopCategoryRes?.data?.Category;

  const { data: shopCategorytwoRes, refetch: Mydata } =
    useGetShopCategoriesQuery(
      {
        type: "usedVehicleShopItem",
        parentCategory: categoryName || "",
      },
      { skip: !categoryName },
    );
  const shopCategorytwo = shopCategorytwoRes?.data?.Category;

  const Handleadditioanalshop = (e) => {
    setFilters((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const getCleanFilters = (type, currentFilters) => {
    const queryParams = {
      businessType: currentFilters.businessType,
      filtermethod: type,
    };

    const keys =
      type === "shop"
        ? [
            "shopname",
            "shopCategory",
            "marketPlace",
            "shopid",
            "specialoffer",
            "sale",
          ]
        : [
            "itemname",
            "categoryid",
            "subCategoryid",
            "country",
            "state",
            "city",
            "specialoffer",
            "min",
            "max",
            "brandName",
            "modelYear",
          ];

    keys.forEach((k) => {
      if (
        currentFilters[k] &&
        currentFilters[k].trim() !== "" &&
        currentFilters[k] !== "undefined"
      ) {
        queryParams[k] = currentFilters[k].trim();
      }
    });

    return queryParams;
  };

  const FilterHandler = async () => {
    setIsloading(true);
    const newFilters = {
      ...filters,
      itemname: "",
      categoryid: "",
      subCategoryid: "",
      country: "",
      state: "",
      city: "",
      min: "",
      max: "",
      brandName: "",
      modelYear: "",
    };
    setFilters(newFilters);
    setShopdata([]);
    setItemmdata([]);

    try {
      const res = await triggerFilter(
        getCleanFilters("shop", newFilters),
      ).unwrap();
      if (res?.success) {
        setShopdata(res.Shop || []);
        setItemmdata(res.vehicleItem || []);
        updateFilteredData(
          shopType,
          res.Shop || [],
          res.vehicleItem || [],
          newFilters,
        );
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsloading(false);
    }
  };

  const FilterHandleritem = async () => {
    setIsloading(true);
    const newFilters = {
      ...filters,
      shopname: "",
      shopCategory: "",
      marketPlace: "",
      shopid: "",
      specialoffer: "",
      sale: "",
    };
    setFilters(newFilters);
    setShopdata([]);
    setItemmdata([]);

    try {
      const res = await triggerFilter(
        getCleanFilters("vehicleitem", newFilters),
      ).unwrap();
      if (res?.success) {
        setShopdata(res.Shop || []);
        setItemmdata(res.vehicleItem || []);
        updateFilteredData(
          shopType,
          res.Shop || [],
          res.vehicleItem || [],
          newFilters,
        );
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsloading(false);
    }
  };

  return (
    <>
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <ShareModel
        showmodal={showmodal}
        handleClosemodal={handleClosemodal}
        handleShowshare={handleShowshare}
      />
      <Container>
        <BackArrow back="/BuyingSide" mystyle="buy-used-cars-mobile-back d-lg-none" />
        <Row className="buy-used-cars-row">
          <Col lg="4" className="screenHeight background-image">
            <div className="border b-radius height_100">
              <BuyingFilter
                Handleadditioanalshop={Handleadditioanalshop}
                FilterHandler={FilterHandler}
                dataCategory={dataCategory}
                createshopcategory={createshopcategory}
                shopCategory={shopCategory}
                Handledata={Handledata}
                shopCategorytwo={shopCategorytwo}
                Mydata={Mydata}
                FilterHandleritem={FilterHandleritem}
                additionalShopCategoryData={filters}
              />
            </div>
          </Col>
          <Col lg="8" className="screenHeight">
            <div className="border b-radius ps-2 pe-2">
              <BackArrow back="/BuyingSide" mystyle="ps-2 pt-1 d-none d-lg-block" />
              <ShopAdds />
              <Shops
                link="/Byvehicleuserprofile"
                title="Used Cars"
                isloading={isloading}
                data={0}
                handleShow={handleShow}
                shopdata={shopdata}
                itemmdata={itemmdata}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default BuyUsedCars;
